import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=4f6509e1&scoped=true"
import script from "./privacy-policy.vue?vue&type=script&lang=js"
export * from "./privacy-policy.vue?vue&type=script&lang=js"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=4f6509e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6509e1",
  null
  
)

export default component.exports